export default __webpack_public_path__ + "static/media/plusorange.d21a49f7.svg";